import { changePasswordStyles } from "@insite/content-library/Widgets/ChangePassword/ChangePassword";
import { css } from "styled-components";

changePasswordStyles.userInformationTitle = {
    variant: "h4",
    as: "h2",
    size: 18,
    fontFamily: "Lato",
    color: "text.main",
    css: css`
        font-weight: bold;
    `,
};
